module.exports = __webpack_public_path__ + "static/media/excel-template.9ce3caae.svg";